import { useQuery } from "@tanstack/react-query";

import { fetchAddressSuggestions } from "@/sales-tools/home-product/api/addressSuggestions";
import { useLogger } from "@/sdk";

export const useAddressSearch = (searchText: string, isEnabled = true) => {
    const logger = useLogger({ module: "useAddressSearch", supportTeam: "sales" });

    return useQuery({
        queryKey: ["address-lookup", searchText],
        queryFn: async () => {
            return fetchAddressSuggestions(logger, searchText);
        },
        retry: false,
        enabled: isEnabled,
    });
};
